// Global calendar service for schedule meeting functionality
export interface ScheduleMeetingData {
  type: 'client' | 'prospect';
  id: number;
  name: string;
  email?: string;
  phone?: string;
}

class CalendarService {
  private scheduleMeetingCallback: ((data: ScheduleMeetingData) => void) | null = null;
  private openCalendarCallback: (() => void) | null = null;

  // Register callback to open calendar with pre-populated data
  onScheduleMeeting(callback: (data: ScheduleMeetingData) => void) {
    this.scheduleMeetingCallback = callback;
  }

  // Register callback to open calendar panel
  onOpenCalendar(callback: () => void) {
    this.openCalendarCallback = callback;
  }

  // Trigger schedule meeting from anywhere in the app
  scheduleMeeting(data: ScheduleMeetingData) {
    if (this.scheduleMeetingCallback) {
      this.scheduleMeetingCallback(data);
    }
  }

  // Open calendar panel from anywhere in the app
  openCalendar() {
    if (this.openCalendarCallback) {
      this.openCalendarCallback();
    }
  }

  // Clear callback
  clearCallback() {
    this.scheduleMeetingCallback = null;
    this.openCalendarCallback = null;
  }
}

export const calendarService = new CalendarService();